/* RESPONSIBLE TEAM: team-automation-foundations */
import ConditionalBranchesSerializer from './conditional-branches';

export default ConditionalBranchesSerializer.extend({
  serialize(snapshot: any, options: any) {
    let json = this._super(snapshot, options);
    // Serialize as conditional_branches for backend compatibility
    json.type = 'operator/visual-builder/step/conditional-branches';
    return json;
  },
});
